import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, Typography, Button, Modal, IconButton } from "@mui/material";
import cross from "../../assets/img/cross.png";
import { useTheme } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  height: "40vh", // Keeps modal height unchanged
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
};

const MoreDetailsModal = ({ open, onClose, handleSubmit, transaction }) => {
  const theme=useTheme();
  const [paymentStatus, setPaymentStatus] = useState("");
  const [deliveryPerson, setDeliveryPerson] = useState("");
  const [locationArea, setLocationArea] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  useEffect(() => {
    if (transaction) {
      setPaymentStatus(transaction.payment_status);
      setDeliveryPerson(transaction.delivery_person_name);
      setLocationArea(`${transaction.area}`);
      setPaymentAmount(transaction.total_price);
      setPaymentMethod(transaction.payment_type);
    }
  }, [transaction]);

  const onSubmit = (e) => {
    e.preventDefault();
    const orderData = {
      paymentStatus,
      deliveryPerson,
      locationArea,
      paymentAmount,
      paymentMethod,
    };
    handleSubmit(orderData); // Pass form data to the parent
    onClose(); // Close modal after submission
  };

  return (
    
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="order-details-modal-title"
    >
      <Box sx={style} component="form" onSubmit={onSubmit}>
        {/* Modal Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.light,
            padding: "20px",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography id="order-details-modal-title" variant="h6">
            Order Details
          </Typography>
          <IconButton onClick={onClose} sx={{ color: "#fff" }}>
            <img src={cross} alt="Close" style={{ width: "30px", height: "30px" }} />
          </IconButton>
        </Box>

        {/* Modal Body */}
        <Box sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            {/* First Row: Payment Status + Verify Button, Delivery Personnel, Location Area */}
            <Grid item xs={4}>
              <Box display="flex" gap={1}>
                <TextField
                  fullWidth
                  label="Verify Payment Status"
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e.target.value)}
                  variant="outlined"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    style: { backgroundColor: "#E0E0E0", padding: "1px" },
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: "56px",textTransform:'capitalize' }}
                >
                  Verify
                </Button>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Assigned Delivery Personnel"
                value={deliveryPerson}
                onChange={(e) => setDeliveryPerson(e.target.value)}
                variant="outlined"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  style: { backgroundColor: "#E0E0E0", padding: "1px" },
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Location Area"
                value={locationArea}
                onChange={(e) => setLocationArea(e.target.value)}
                variant="outlined"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  style: { backgroundColor: "#E0E0E0", padding: "1px" },
                }}
              />
            </Grid>

            {/* Second Row: Payment Amount, Payment Method */}
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Payment Amount"
                value={paymentAmount}
                onChange={(e) => setPaymentAmount(e.target.value)}
                variant="outlined"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  style: { backgroundColor: "#E0E0E0", padding: "1px" },
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="Payment Method"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                variant="outlined"
                required
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  style: { backgroundColor: "#E0E0E0", padding: "1px" },
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default MoreDetailsModal;
